// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__gDLbF","empty":"ModalGraph_empty__21bIt"};